'use client';

import type { ReactNode } from 'react';
import { Text } from '../../../../../components/styled/text';

type ToolInlineStatusLineProps = {
  icon?: ReactNode;
  text: string;
  isError?: boolean;
};

export function ToolInlineStatusLine({
  icon,
  text,
  isError,
}: ToolInlineStatusLineProps) {
  const color = isError ? 'fg.error' : 'fg.muted';

  return (
    <Text
      as="span"
      display="inline-flex"
      alignItems="center"
      gap={1}
      fontSize="xs"
      lineHeight={1.5}
      color={color}
    >
      {icon ? (
        <Text as="span" display="inline-flex" flexShrink={0} color={color}>
          {icon}
        </Text>
      ) : null}
      {text}
    </Text>
  );
}
